/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CashCreditsAllocationOptionDto } from './CashCreditsAllocationOptionDto';
export type CashCreditsReportRowDto = {
    sourceType: CashCreditsReportRowDto.sourceType;
    sourceInvoiceId?: string | null;
    sourceClientId?: string | null;
    sourceInvoiceNumber: string;
    policyId?: string | null;
    /**
     * Policy reference (Ando quote id or policy id)
     */
    policy?: string | null;
    /**
     * MTA version number
     */
    mtaVersion?: number | null;
    clientId: string;
    clientName: string;
    date: string;
    /**
     * True when source invoice payment type is FUNDED
     */
    funded: boolean;
    type: CashCreditsReportRowDto.type;
    /**
     * Available balance for this line item
     */
    balance: number;
    /**
     * Maximum amount that can be refunded from this line item
     */
    processableBalance: number;
    /**
     * Maximum amount that can be allocated from this line item
     */
    allocatableBalance: number;
    /**
     * Total unallocated cash for the client (invoice + manual)
     */
    totalUnallocatedCash: number;
    hasPriorWriteOffBalance: boolean;
    hasOpenQuotes: boolean;
    unpaidPoliciesCount: number;
    defaultAction: CashCreditsReportRowDto.defaultAction;
    defaultAllocationInvoiceId?: string | null;
    allocationOptions: Array<CashCreditsAllocationOptionDto>;
    availableRefundRecipients: Array<'CLIENT' | 'BUSINESS' | 'PREMIUM_FUNDER'>;
};
export namespace CashCreditsReportRowDto {
    export enum sourceType {
        INVOICE = 'INVOICE',
        CLIENT = 'CLIENT',
    }
    export enum type {
        CASH = 'CASH',
        CREDIT = 'CREDIT',
    }
    export enum defaultAction {
        ALLOCATE = 'ALLOCATE',
        REFUND = 'REFUND',
    }
}

